<div class="w-12 _expand z-1">
    <!-- close -->
    <div class="_overlay z-1 p-t-3-s p-t-3-m flex-justify-end flex flex-middle">
        <div class="_inputBoxSM m-l w-12 flex flex-justify-end flex-middle"
             *ifSize="'SM'">
            <input type="text"
                   cy-searchInput
                   [(ngModel)]="termModel"
                   (keyup)="keyup($event)"
                   class="flex-grow m-r-2 m-l-1"
                   #input
                   [placeholder]="'What are you looking for?' | translate">
            <i class="_icon icon-search inline-flex m-r-1"
               aria-hidden="true"></i>
        </div>
        <div>
            <div class="wrap flex flex-middle height-100">
                <i class="icon-close cursor-pointer inline-flex"
                   (click)="close()"></i>
            </div>
        </div>
    </div>
    <div class="fill pe-none z-2">
        <div class="wrap center">
            <div class="c-6 m-r-0 m-b-0 "
                 *ifSize="'XL'">
                <div class="flex flex-middle height-100 flex-justify-end">
                    <div class="_inputBox w-12 flex flex-justify-end flex-middle pos-relative"
                         #inputBoxOn>
                        <i class="_icon icon-search inline-flex pos-absolute"
                           aria-hidden="true"></i>
                        <input type="text"
                               cy-searchInput
                               [(ngModel)]="term"
                               (keyup)="keyup($event)"
                               class="flex-grow m-r-2 m-l-1"
                               #input
                               [placeholder]="'What are you looking for?' | translate">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<button class="flex flex-middle pos-relative"
        (click)="toggleVisibility(true)"
        [sizeClass]="'XL:_inputBoxOff'"
        #inputBoxOff>
    <i class="_icon icon-search cursor-pointer _iconOff inline-flex"
       aria-hidden="true"></i>
    <span *ifSize="'XL'"
          class="p2 _search-text">{{'Search' | translate}}</span>
</button>